import asyncSweetScroll from '@/helpers/sweet_scroll';

export function toLandingLeadForm(e) {
  e?.preventDefault();

  asyncSweetScroll('article.landing_lead_form');
}
